import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useAlert } from 'react-alert'

import { createCustomerShort } from '../../../main/usecases'

import { useForm } from '../../hooks/useForm'
import { goToUrl } from '../../utils'
import { useModalBox } from '../../contexts'
import { Input, Button } from '..'

import * as S from './styles'

const NewRegisterForm = ({ valueToCpf }: any) => {
  const cpf = useForm('cpf')
  const name = useForm()
  const birth = useForm()
  const history = useHistory()
  const { modalClose } = useModalBox()
  const alert = useAlert()

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    const body = {
      nome: name.value,
      dataNascimento: birth.value,
      cpf: cpf.value
    }

    try {
      const response = await createCustomerShort().post(body)

      modalClose(true)
      goToUrl(history, `/meus-pacientes/${response.cdCliente}/prontuario`)
    } catch (error) {
      alert.show((error as Error).message || 'CPF já cadastrado.', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  useEffect(() => {
    ;(async () => {
      try {
        if (valueToCpf) {
          cpf.setValue(valueToCpf)
        }
      } catch (error) {
        console.error(error)
      }
    })()
  }, [cpf, valueToCpf])

  return (
    <form onSubmit={onSubmit}>
      <Input
        labelColor="#4F4F4F"
        label="CPF*"
        name="cpf"
        type="text"
        maxLength={14}
        required
        {...cpf}
      />
      <Input
        labelColor="#4F4F4F"
        label="Nome completo*"
        name="nome"
        maxLength={150}
        type="text"
        required
        {...name}
      />
      <Input
        labelColor="#4F4F4F"
        label="Data de nascimento"
        name="data de nascimento"
        type="date"
        max={'2222-10-29'}
        {...birth}
      />
      <S.ButtonContainer>
        <Button>Prosseguir</Button>
        <button
          onClick={() => {
            modalClose(true)
            goToUrl(history, `/meus-pacientes/dados-cadastrais`, {
              cpf: cpf.value,
              name: name.value,
              birth: birth.value
            })
          }}
          type="button"
          className="access-complete-register-button"
        >
          Acessar cadastro completo
        </button>
      </S.ButtonContainer>
    </form>
  )
}

export default NewRegisterForm
